// src/components/PropertyFormSections/LandlordDetails.js
import React from 'react';

const LandlordDetails = ({ formData, handleInputChange }) => {
    return (
        <>
            {/* Landlord & Deposit */}
            <div className="grid grid-cols-2 gap-2">
                <div className="mb-4">
                    <label className="block font-bold">Landlord Name</label>
                    <input
                        type="text"
                        name="landlord_name"
                        value={formData.landlord_name}
                        onChange={handleInputChange}
                        placeholder="e.g., John Doe"
                        className="border p-2 w-full"
                    />
                </div>
                <div className="mb-4">
                    <label className="block font-bold">Deposit</label>
                    <input
                        type="text"
                        name="deposit"
                        value={formData.deposit}
                        onChange={handleInputChange}
                        placeholder="e.g., ₹10 Lac"
                        className="border p-2 w-full"
                    />
                </div>
            </div>

            {/* Price per Sqft & Pre-Leased */}
            <div className="grid grid-cols-2 gap-2">
                <div className="mb-4">
                    <label className="block font-bold">Price per Sq.Ft.</label>
                    <input
                        type="text"
                        name="price_per_sqft"
                        value={formData.price_per_sqft}
                        onChange={handleInputChange}
                        placeholder="e.g., ₹150/sq.ft./month"
                        className="border p-2 w-full"
                    />
                </div>
                <div className="mb-4">
                    <label className="block font-bold">Pre-Leased</label>
                    <input
                        type="text"
                        name="pre_leased"
                        value={formData.pre_leased}
                        onChange={handleInputChange}
                        placeholder="e.g., Yes, 3 years"
                        className="border p-2 w-full"
                    />
                </div>
            </div>

            {/* Landlord Contact */}
            <div className="mb-4">
                <label className="block font-bold">Landlord Contact</label>
                <input
                    type="text"
                    name="landlord_contact"
                    value={formData.landlord_contact}
                    onChange={handleInputChange}
                    placeholder="e.g., +91 1234567890"
                    className="border p-2 w-full"
                />
            </div>
        </>
    );
};

export default LandlordDetails;